import React, {useState, useRef} from 'react'
import Card from './Card'

let CARD_W = 90
let CARD_H = 125
let HAND_HEIGHT = CARD_H + 4
let OVERLAP = 60

let Hand = ({hand, onPlayCard, screenWidth, screenHeight}) => {
  let [dragging, setDragging] = useState(null) // index of card being dragged
  let [dragPos, setDragPos] = useState({x: 0, y: 0})
  let startPos = useRef({x: 0, y: 0})

  let handleMouseDown = (e, idx) => {
    e.preventDefault()
    setDragging(idx)
    startPos.current = {x: e.clientX, y: e.clientY}
    setDragPos({x: 0, y: 0})

    let onMove = ev => {
      setDragPos({
        x: ev.clientX - startPos.current.x,
        y: ev.clientY - startPos.current.y,
      })
    }

    let onUp = ev => {
      window.removeEventListener('mousemove', onMove)
      window.removeEventListener('mouseup', onUp)

      // If dragged above the hand area, play the card
      if (ev.clientY < screenHeight - HAND_HEIGHT) {
        onPlayCard(hand[idx], ev.clientX, ev.clientY)
      }

      setDragging(null)
      setDragPos({x: 0, y: 0})
    }

    window.addEventListener('mousemove', onMove)
    window.addEventListener('mouseup', onUp)
  }

  let handleTouchStart = (e, idx) => {
    let touch = e.touches[0]
    setDragging(idx)
    startPos.current = {x: touch.clientX, y: touch.clientY}
    setDragPos({x: 0, y: 0})

    let onMove = ev => {
      ev.preventDefault()
      let t = ev.touches[0]
      setDragPos({
        x: t.clientX - startPos.current.x,
        y: t.clientY - startPos.current.y,
      })
    }

    let onEnd = ev => {
      window.removeEventListener('touchmove', onMove)
      window.removeEventListener('touchend', onEnd)

      let t = ev.changedTouches[0]
      if (t.clientY < screenHeight - HAND_HEIGHT) {
        onPlayCard(hand[idx], t.clientX, t.clientY)
      }

      setDragging(null)
      setDragPos({x: 0, y: 0})
    }

    window.addEventListener('touchmove', onMove, {passive: false})
    window.addEventListener('touchend', onEnd)
  }

  let totalWidth = hand.length > 0 ? CARD_W + (hand.length - 1) * OVERLAP : 0
  let startX = (screenWidth - totalWidth) / 2

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: screenWidth,
        height: HAND_HEIGHT,
        backgroundColor: '#1a1a1a',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <div style={{position: 'relative', height: CARD_H, width: totalWidth}}>
        {hand.map((card, i) => {
          let isDragging = dragging === i
          return (
            <div
              key={card.deckCardId || i}
              onMouseDown={e => handleMouseDown(e, i)}
              onTouchStart={e => handleTouchStart(e, i)}
              style={{
                position: 'absolute',
                left: i * OVERLAP,
                top: 0,
                zIndex: isDragging ? 100 : i,
                transform: isDragging ? `translate(${dragPos.x}px, ${dragPos.y}px)` : 'none',
                cursor: 'grab',
                transition: isDragging ? 'none' : 'transform 0.15s',
                border: card.fromBoard ? '2px solid #4a7eff' : '2px solid transparent',
                borderRadius: 6,
              }}>
              <Card card={card} width={CARD_W} height={CARD_H} />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Hand
